// extracted by mini-css-extract-plugin
export default {"switchLanguage":"Options_switchLanguage__slEt0","switchTheme":"Options_switchTheme__ROOXJ"};